/**
 * 防欺诈功能初始化
 *
 * 功能说明:
 * 1. 加载防欺诈脚本
 *    - 从环境配置获取组织ID和商户ID
 *    - 动态创建并加载online-metrix.net的防欺诈脚本
 *
 * 2. 会话管理
 *    - 在sessionStorage中记录结账类型
 *    - 记录用户进入收银台的日志
 *
 * 3. 错误处理
 *    - 捕获并处理可能的存储和日志记录错误
 */

// 导入日志记录工具
import { addLog } from '@/api/common';

/**
 * 初始化防欺诈功能
 * @param {string} key - 订单密钥
 */
export const initFraudPrevention = (key) => {
  // 从环境配置中获取防欺诈服务所需的ID
  const { MD_ORI_ID, MD_MERCHANT_ID } = require('@/config/env.' + process.env.NODE_ENV);

  // 创建script标签用于加载防欺诈脚本
  const script = document.createElement('script');

  // 设置防欺诈脚本的URL,包含必要的参数
  script.src = `https://h.online-metrix.net/fp/tags.js?org_id=${MD_ORI_ID}&session_id=${MD_MERCHANT_ID}${key}`;

  // 将脚本添加到页面中
  document.body.appendChild(script);

  try {
    // 在会话存储中记录结账类型
    window.sessionStorage.setItem(`checkout_type_${key}`, '1');

    // 记录用户进入收银台的日志
    addLog({
      key,
      message: '进入收银台:' + window.location.href,
    });
  } catch (error) {
    // 捕获并静默处理可能的存储和日志记录错误
  }
};
